import FloatingPanel from "@imminently/decisively-ui/FloatingPanel";
/**
 * @deprecated Use `@imminently/decisively-ui/Popover` instead.
 * This Radix-based Popover is deprecated in favor of the core Popover component.
 */
import * as ReactPopover from "@radix-ui/react-popover";
import clsx from "clsx";
import type { ComponentPropsWithoutRef, ElementRef } from "react";
import styles from "./popover.module.scss";

/**
 * @deprecated Use `@imminently/decisively-ui/Popover` instead.
 */
const Popover = ReactPopover.Root;
/**
 * @deprecated Use `@imminently/decisively-ui/Popover.Trigger` instead.
 */
const PopoverTrigger = ReactPopover.Trigger;

/**
 * @deprecated Use `@imminently/decisively-ui/Popover.Content` instead.
 */
export type PopoverContentProps = ComponentPropsWithoutRef<typeof ReactPopover.Content> & {
  portal?: ComponentPropsWithoutRef<typeof ReactPopover.Portal>;
  ref?: React.Ref<ElementRef<typeof ReactPopover.Content>>;
};

const PopoverContent = ({
  className,
  children,
  asChild,
  align = "start",
  sideOffset = 4,
  portal: { container = document.body } = {},
  ref,
  ...props
}: PopoverContentProps) => (
  <ReactPopover.Portal container={container}>
    <ReactPopover.Content
      ref={ref}
      align={align}
      asChild={true}
      sideOffset={sideOffset}
      className={clsx(styles.popover, className)}
      {...props}
    >
      <FloatingPanel asChild={asChild}>{children}</FloatingPanel>
    </ReactPopover.Content>
  </ReactPopover.Portal>
);

/**
 * @deprecated Use `@imminently/decisively-ui/Popover` instead.
 */
export { Popover, PopoverTrigger, PopoverContent };
